module.exports = __webpack_public_path__ + "static/media/droopy_upper.29ac9a26.svg";